import microuniversoApi from 'app/api/microuniversoApi'
import { alterarMostruarioItem } from 'app/use-cases/orcamento/alterarMostruarioItem' // PA 487087
import * as colunasGridOrcamentoActions from 'app/redux/colunasGridOrcamentoSlice'
import { map } from 'p-iteration'
import { WindowMU } from 'app/types/WindowMU'

declare var window: WindowMU

import {


    produtoPodeSerAdicionadoAutomaticamenteAoOrcamento
} from '../../use-cases';

import { obterOrcamentoAtual } from 'app/use-cases/orcamento/obterOrcamentoAtual'
import { useAppSelector } from 'app/redux/hooks'
import { atualizarItemAction, desselecionarItemAction, desselecionarTodosOsItensAction, selecionarItemAction, selecionarTodosOsItensAction, toggleSelecionarItemAction } from 'app/redux/orcamentoSlice'
import store from 'app/redux/store/store'
import { ICentroCusto } from 'app/types/ICentroCusto'
import { IColuna } from 'app/types/IColuna'
import { IOrcamento } from 'app/types/IOrcamento'
import { ITipoFaturamento } from 'app/types/ITipoFaturamento'
import { Parametro, ParametroPorItem } from 'app/types/Parametro'
import { obterColunasGridItens } from 'app/use-cases/obterColunasGridItens'
import { obterPermissao } from 'app/use-cases/obterPermissao'
import { alterarOrdemPedidoCompraItem } from 'app/use-cases/orcamento/alterarOrdemPedidoCompraItem'
import { Ambiente } from 'app/use-cases/orcamento/ambiente/Ambiente'
import { obterAmbientesPelosItens } from 'app/use-cases/orcamento/ambiente/obterAmbientesPelosItens'
import { obterProximaCorAmbiente } from 'app/use-cases/orcamento/ambiente/obterProximaCorAmbiente'
import { definirCentroCustoItem } from 'app/use-cases/orcamento/definirCentroCustoItem'
import { definirDespesasInclusasParaItemOrcamento } from 'app/use-cases/orcamento/definirDespesasInclusasParaItensOrcamento'
import { definirPedidoDeCompraItem } from 'app/use-cases/orcamento/definirPedidoDeCompraItem'
import { editarAmbiente } from 'app/use-cases/orcamento/editarAmbienteItem'
import { definirOfertaSeletivaItem } from 'app/use-cases/orcamento/itens/definirOfertaSeletivaItem'
import { RespostaConsultaItensOrcamento } from 'app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento'
import { ControllerLegado } from 'app/types/ControllerLegado'
import { TelaEdicaoItensContainer } from '../editar-item/TelaEdicaoItensContainer'
import { definirFilialRetiradaItem } from 'app/use-cases/orcamento/definirFilialRetiradaItem'
import { definirFilialTransferenciaItem } from 'app/use-cases/orcamento/definirFilialTransferenciaItem'
import { definirTipoFaturamentoItem } from 'app/use-cases/orcamento/definirTipoFaturamentoItem'

import { obterParametros, obterParametrosPorOidItem } from 'app/use-cases/parametro/obterParametros'
import { Dict } from 'app/utils/Dict'
//import { ItemOrcamentoInfoView } from 'app/views/orcamento/itemOrcamentoView'
import globalMU from 'globalMU'
import { forEachSeries } from 'p-iteration'
import pMemoize from 'p-memoize'
import * as R from "ramda"
import React, { useCallback, useEffect, useEffectEvent, useMemo, useRef, useState } from 'react'
import { substituirItemEmArray } from 'substituirItemEmArray'
import { v4 as uuidv4 } from 'uuid'
import { IFilial } from "../../types/IFilial"
import { IItemOrcamento } from "../../types/IItemOrcamento"
import {
    adicionarProdutos, alterarPercentualMarkupItem as alterarPercentualMarkupItemUseCase, alterarPrecoItem as alterarPrecoItemUseCase,
    alterarQuantidadeItem as alterarQuantidadeItemUseCase, alterarTipoEntregaItens, tratamentoErroPadrao, reordenarOrcamento, excluirItens as excluirItensUseCase
} from '../../use-cases'
import { PesquisaCorTintaContainer } from '../pesquisa-produtos/pesquisa-cor/PesquisaCorTintaContainer'
import { useRecuperarCestaProdutosAnterior } from './useRecuperarCestaProdutosAnterior'
import { useRecuperarOrcamentoEmAndamento } from './useRecuperarOrcamentoEmAndamento'
//import { removerBreadcrumb2 } from '../breadcrumb2/breadcrumb2Utils'
import { useMenuConsultaProduto } from '../menu-consulta-produtos/useMenuConsultaProduto'
import { PaginaPesquisaProdutoContainer } from '../pesquisa-produtos/PaginaPesquisaProdutoContainer'
import { removerComponenteReact, renderizarComponentReact } from '../renderizarOuRemoverComponentReact'
import { BarraFerramentas, BarraFerramentasContext } from './barra-ferramentas/BarraFerramentas'
import { ConsultaItensDialog } from "./consulta-itens/ConsultaItensDialog"
import { GridItens, GridItensContext } from './grid-itens/GridItens'
import { obterColunas } from './grid-itens/obterColunas'
import { OrdenarItens } from "./ordenar-itens/OrdenarItens"
import { DadosParaAvaliarExibicaoModalVendaSobEncomenda, ehNecessarioMostrarModalVendaSobEncomenda } from 'app/use-cases/orcamento/ehNecessarioMostrarModalVendaSobEncomenda'
import { ModalVendaSobEncomendaContainer } from '../editar-item/modal-venda-sob-encomenda/ModalVendaSobEncomendaContainer'

const Backbone = require('backbone')
import { obterColunasConsultaItens } from './grid-itens/obterColunasConsultaItens'
import { Breadcrumb2Container } from '../breadcrumb2/Breadcrumb2Container'
import { alterarDataPrevisaoEntregaItens } from 'app/use-cases/orcamento/alterarDataPrevisaoEntregaItens'
import { DataFormatoEN } from 'app/types/DataFormatoEN'
//import { alterarEntregaPosteriorItem } from 'app/use-cases/orcamento/alterarEntregaPosteriorItem'
import { RegistrarPerdaCotacaoContainer } from '../editar-item/registrar-perda-cotacao/RegistrarPerdaCotacaoContainer'
import { CompararProdutosContainer } from '../comparar-produtos/CompararProdutosContainer'
import { IProduto } from 'app/types/produto/IProduto'
import { alterarEntregaPosteriorItens } from 'app/use-cases/orcamento/alterarEntregaPosteriorItens'
import { associarCorAction, desassociarCorAction } from 'app/redux/corPorAmbienteSlice'
import * as gridItensActions from 'app/redux/gridItensSlice'
import { DetalheItemContainer } from './detatlhe-item/DetalheItemContainer'
import { ProdutosControleLoteContainer } from './produto-controle-lote/ProdutosControleLoteContainer'
import { ProdutoLoteContainer } from './produto-controle-lote/produto-lote/ProdutoLoteContainer'
import { definirVendaSobEncomendaItem } from 'app/use-cases/orcamento/definirVendaSobEncomendaItem'
import { ITipoEntrega } from 'app/types/ITipoEntrega'
//import { ITurnoEntrega } from 'app/types/ITurnoEntrega'
import { alterarDataPrevisaoEntregaItem } from 'app/use-cases/orcamento/alterarDataPrevisaoEntregaItem'
import { alterarDataMarcadaEntregaItem } from 'app/use-cases/orcamento/alterarDataMarcadaEntregaItem'
import { CodigoTurnoEntrega } from 'app/types/CodigoTurnoEntrega'
import { alterarTurnoEntregaItem } from 'app/use-cases/orcamento/alterarTurnoEntregaItem'
import { alterarTipoEntregaItem } from 'app/use-cases/orcamento/alterarTipoEntregaItem'
import { CodigoTipoEntrega } from 'app/types/CodigoTipoEntrega'
//import { atualizarOrcamento } from 'app/use-cases/orcamento/atualizarOrcamento'
//import { atualizarOrcamentoResumo } from 'app/use-cases/orcamento/atualizarOrcamentoResumo'
import { definirEncomendaExpressaItem } from 'app/use-cases/orcamento/definirEncomendaExpressaItem'
import { definirPrioridadeMontagemItem } from 'app/use-cases/orcamento/definirPrioridadeMontagemItem'
import { simularDescontoItem } from 'app/use-cases/orcamento/simularDescontoItem'
//import { preencherDadosTratamentoMadeira } from 'app/use-cases/orcamento/preencherDadosTratamentoMadeira'
import { TratamentoMadeiraContainer } from '../madeira/TratamentoMadeiraContainer'
//import { ItensOrcamento } from 'app/models/orcamento/itemOrcamento'
import { RemoverServicosAgregados } from 'app/use-cases/orcamento/RemoverServicosAgregados'
import { SimuladorPrecoContainerDialog } from '../simulacao-preco/SimuladorPrecoContainerDialog'
import { SolicitarSenhaContainer } from '../senha/SolicitarSenhaContainer'
import { EditarPrecoTintaContainer } from '../tinta/EditarPrecoTintaContainer'


// Constantes para nomes de parâmetros
const PARAMETROS_GRID = [
    "CUSTO_PARA_GERAR_MARKUP",
    "UTILIZA_ETIQUETA_PESAGEM_VENDA",
    "UTILIZA_CONTROLE_PRODUCAO",
    "DESTACAR_PRODUTOS_COM_RETIRADA_CD_ORCAMENTO",
    "EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO",
    "ACEITAR_PRODUTO_SEM_ESTOQUE",
    "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL",
    "DEFINIR_PREVISAO_ENTREGA_POR_ITEM",
    "APURAR_ST_ORCAMENTO",
    "VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM",
    "ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS",
    "AMBIENTE_ORCAMENTO",
    "AMBIENTE_ORCAMENTO_POR_FILIAL",
    "CHAVE_MOVIMENTACAO_ORCAMENTO",
    "VISUALIZA_MARKUP_PRODUTO_ORCAMENTO",
    "DESABILITAR_PAGINA_ORDEM_SEPARACAO_CONFERENCIA_SAIDA",
    "OFERTA_SELETIVA",
    "EXIBIR_OUTRAS_DESPESAS_ITENS_ORCAMENTO",
    "EXIBIR_COLUNA_ESTOQUE_TOTAL_PRODUTO_VENDAS",
    "CASAS_DECIMAIS_PRECO_VENDA",
    "ORCAMENTO_MASCARA_QUANTIDADE",
    "PERMITIR_OBSERVACAO_POR_ITEM",
    "TRATAR_VENDAS_SOB_ENCOMENDA",
    "TRABALHA_CUPOM_DESCONTO",
    "TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM",
    "PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"
];

const PARAMETROS_POR_FILIAL = [
    "TRABALHA_ORDEM_CARGA_ORDEM_ENTREGA_MONTAGEM_CARGA_FATURAMENTO",
    "UTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO", //474918
    "UTILIZA_RECURSO_ENCOMENDA_EXPRESSA",
    "OBRIGATORIO_INFORMAR_TURNO_ORCAMENTO", //475897
    "BLOQUEAR_FATURAMENTO_DIRETO_CLIENTE_RETIRADA_OUTRO_LOCAL",
    "DESTACAR_PRODUTOS_COM_RETIRADA_CD_ORCAMENTO",
    "UTILIZA_SERVICO_AGREGADO_ORCAMENTO",
    "VENDAS_INSERCAO_RAPIDA_SEMPRE_ADICIONAR_QUANTIDADE_AO_INFORMAR_O_MESMO_PRODUTO" // 491040
];

// Itens que servem de ancora de scroll depois de excluir, do mais proximo da linha excluida para o
// mais distante: primeiro os vizinhos SOBREVIVENTES subindo a partir da primeira linha excluida,
// depois os que ficam abaixo da ultima (caso a exclusao tenha comecado na primeira linha).
//
// Devolve uma LISTA, e nao um unico identificador, porque nem toda linha da lista de itens esta
// renderizada: sub-item de tinta com o pai recolhido nao vai para o DOM (ver itemSeraExibido em
// GridItens.tsx). Assim o reposicionamento cai para o proximo candidato em vez de desistir.
const _obterIdentificadoresAncoraScroll = (itensDaGrade: IItemOrcamento[], itensExcluidos: IItemOrcamento[]) => {
    const excluidos = new Set((itensExcluidos ?? []).map(i => i.Identificador))

    const indicesExcluidos = (itensDaGrade ?? [])
        .map((item, indice) => excluidos.has(item.Identificador) ? indice : -1)
        .filter(indice => indice >= 0)

    if (indicesExcluidos.length === 0) return []

    const identificadoresAcima = R.reverse(itensDaGrade.slice(0, Math.min(...indicesExcluidos)))
    const identificadoresAbaixo = itensDaGrade.slice(Math.max(...indicesExcluidos) + 1)

    return [...identificadoresAcima, ...identificadoresAbaixo]
        .filter(item => !excluidos.has(item.Identificador))
        .map(item => item.Identificador)
}

// Depois de excluir, a grade e REMONTADA (o `key` do GridItensContext.Provider e o renderFlag do
// redux, que excluirItens atualiza) — e container remontado nasce sem a posicao de scroll que
// tinha, jogando a tela para longe da linha que o usuario acabou de excluir. Aqui o scroll do
// container da grade e recolocado na linha vizinha a excluida.
const _reposicionarScrollGridNaLinha = (identificadoresAncora: number[]) => {
    if ((identificadoresAncora ?? []).length === 0) return

    const reposicionar = (tentativasRestantes: number) => {
        const container = document.getElementById("container-rolavel-grid-itens")

        const linha = container == null ? null : R.head(
            identificadoresAncora
                .map(identificador => container.querySelector<HTMLElement>(`.item-orcamento-identificador-${identificador}`))
                .filter(elemento => elemento != null)
        )

        if (!linha) {
            // A grade remonta de forma assincrona (dispatch do redux -> re-render): em vez de
            // desistir no primeiro frame que ainda nao tem as linhas, tenta nos frames seguintes.
            if (tentativasRestantes > 0) requestAnimationFrame(() => reposicionar(tentativasRestantes - 1))
            return
        }

        // `offsetTop` e relativo ao container porque `.containerGrid` tem `position: relative`
        // (ver grid-itens.module.scss). Mesma conta do ItemSelecao.tsx — centraliza a linha no
        // container. Nao usa scrollIntoView aqui porque ele arrastaria o scroll da pagina junto.
        container.scrollTop = Math.max(0, linha.offsetTop - container.clientHeight / 2 + linha.offsetHeight / 2)

        // A grade tem `max-height: 70vh`: se ela ficou fora da janela, so mexer no scroll interno
        // nao traz a linha de volta para o viewport. `block: "nearest"` move o minimo necessario
        // (e nao faz nada quando a grade ja esta visivel).
        const areaContainer = container.getBoundingClientRect()
        const alturaJanela = window.innerHeight || document.documentElement.clientHeight

        if (areaContainer.bottom < 0 || areaContainer.top > alturaJanela) {
            container.scrollIntoView({ block: "nearest" })
        }
    }

    requestAnimationFrame(() => reposicionar(10))
}

export const ItensOrcamentoContainer = (props?: {
    itemOrcamentoController?: ControllerLegado,
    ehParaRenderizarPesquisaDeProdutosImediatamente?: () => boolean
}) => {

    const isMounted = useRef(true)
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    useRecuperarCestaProdutosAnterior(orcamento) // 491123
    // ainda nao esta completo -useRecuperarOrcamentoEmAndamento(orcamento) // 491123
    const totalizadorRedux = useAppSelector(store => store.totalizador)
    const gridItensRedux = useAppSelector(store => store.gridItens)
    const corPorAmbiente = useAppSelector(store => store.corPorAmbiente)
    const aguardandoProcessamento = useAppSelector(store => store.aguardandoProcessamento)
    const [tamanhoFonte, setTamanhoFonte] = useState<number>(0)
    const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState<boolean>(false) // 418506
    const [colunas, setColunas] = useState<IColuna[]>([])
    const [colunasConsultarItens, setColunasConsultarItens] = useState<IColuna[]>([])
    const [ordenarItem, setOrdenarItem] = useState<boolean>(false)
    const [parametrosGridItens, setParametrosGridItens] = useState<Parametro[]>([])
    const [parametrosGridItensPorFilial, setParametrosGridItensPorFilial] = useState<ParametroPorItem[]>([])
    const [dataMaximaParaPrevisaoEntrega, setDataMaximaParaPrevisaoEntrega] = useState<{ year: number, month: number, day: number }>(null)
    const [agruparPorAmbientes, setAgruparPorAmbientes] = useState<boolean>(false)
    const [limparCodigoOuReferenciaFlag, setLimparCodigoOuReferenciaFlag] = useState(uuidv4())
    const [toggleLimparNovoAmbiente, setToggleLimparNovoAmbiente] = useState(uuidv4())
    const [exibirBotaoReservaLote, setExibirBotaoReservaLote] = useState(false)
    const [permitirVisualizarSimulacaoDePreco, setPermitirVisualizarSimulacaoDePreco] = useState(false) //457575
    const [exibirBotaoOrdenarItens, setExibirBotaoOrdenarItens] = useState(false)
    const [filiaisRetiradaPorItem, setFiliaisRetiradaPorItem] = useState<{ [identificadorItem: number]: IFilial[] }>({})
    const [filiaisTransferenciaPorItem, setFiliaisTransferenciaPorItem] = useState<{ [identificadorItem: number]: IFilial[] }>({})
    const [tiposEntrega, setTiposEntrega] = useState<ITipoEntrega[]>([]);
    const [tiposFaturamento, setTiposFaturamento] = useState<ITipoFaturamento[]>([]);
    const [produtosFazemParteCampanhaCupomDesconto, setProdutosFazemParteCampanhaCupomDesconto] = useState<string[]>([])
    const [centrosCusto, setCentrosCusto] = useState<ICentroCusto[]>([])
    const [desativarEdicaoOrdemPedidoCompra, setDesativarEdicaoOrdemPedidoCompra] = useState(false)
    const [exibirConsultaItens, setExibirConsultaItens] = useState(false)
    const [dadosOrcamentoParaConsultaItens, setDadosOrcamentoParaConsultaItens] = useState<RespostaConsultaItensOrcamento>(null)
    const [mostrarLocalRetiradaConsultaItens, setMostrarLocalRetiradaConsultaItens] = useState(false)
    const [dataInicialPrevisaoEntrega, setDataInicialPrevisaoEntrega] = useState(null)
    const [exibirTextoTecnico, setExibirTextoTecnico] = useState<boolean>(null);

    const cachePermissoesRef = useRef<Record<string, boolean>>({})
    const parametrosCacheRef = useRef<{ grid: Parametro[]; porFilial: ParametroPorItem[] } | null>(null);

    const nomeGridItens = "ITENS_ORCAMENTO"
    const nomeGridConsultaItens = "CONSULTAR_ITENS_ORCAMENTO"

    const [tiposFreteDisponiveisPorItem, setTiposFreteDisponiveisPorItem] = useState<{
        [key: number]: {
            IdTipoFrete?: number
            EhFreteEspecial?: boolean
            Descricao?: string
        }[]
    }>({})
    const [parametrosCarregados, setParametrosCarregados] = useState(false)
    const [dadosModalVendaSobEncomenda, setDadosModalVendaSobEncomenda] = useState<{
        mostrar: boolean,
        identificadorItem: number,
        solicitacaoManual: boolean
    }>({
        mostrar: false,
        identificadorItem: null,
        solicitacaoManual: false
    })

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    const itemOrcamentoControllerRef = useRef(props.itemOrcamentoController ?? window?.orcamentoController?.itemOrcamentoController ?? window.ControllerBase?.instances?.ItemOrcamentoController)
    const atualizarTiposFreteDisponiveisPorItemSendoExecutadoRef = useRef(false)

    const [obterFiliaisRetiradaItemMemoize] = useState<Function>(() => pMemoize(async (): Promise<IFilial[]> => {
        if (!isMounted.current) return
        return await microuniversoApi.Orcamento.obterListaFiliais(orcamento.IdentificadorOrcamento, 0, "RETIRADA")
    }))

    const obterFiliaisTransfernciaItem = async (identificadorItem: number): Promise<IFilial[]> => {
        if (!isMounted.current) return
        return await microuniversoApi.Orcamento.obterListaFiliais(orcamento.IdentificadorOrcamento, identificadorItem, "TRANSFERENCIA")
    }

    const [verificaProdutosFazemParteCampanhasDesconto] = useState<Function>(() => pMemoize(async (idsCupons: number[], codigoProdutos: string[]): Promise<string[]> => {
        if (!isMounted.current) return
        return await microuniversoApi.CupomDesconto.VerificaProdutosFazemParteCampanhasDesconto(idsCupons, codigoProdutos)
    }))

    const atualizarTiposFreteDisponiveisPorItem = async () => {
        if (!isMounted.current) return
        if (atualizarTiposFreteDisponiveisPorItemSendoExecutadoRef.current) {
            return
        }



        try {

            atualizarTiposFreteDisponiveisPorItemSendoExecutadoRef.current = true

            if (orcamento.TipoOrcamentoDescricao != "Venda") {
                return
            }

            if (valorParametro("TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM") != "S") {
                return
            }

            const obterTiposFreteDisponiveis = async (identificadorItem: number) => {

                const tiposFretesDisponiveis = await microuniversoApi.Orcamento.buscarTiposFretesDisponiveis(
                    orcamento.IdentificadorOrcamento,
                    identificadorItem
                )

                return {
                    identificadorItem,
                    tiposFretesDisponiveis
                }
            }

            const dadosPorItem = await map(
                orcamento.ItensOrcamento ?? [],
                async item => {

                    return item.Identificador in tiposFreteDisponiveisPorItem ?
                        {
                            identificadorItem: item.Identificador,
                            tiposFretesDisponiveis: tiposFreteDisponiveisPorItem[item.Identificador]
                        } : (await obterTiposFreteDisponiveis(item.Identificador))
                })

            const tiposFreteDisponiveisPorItem_: {
                [key: number]: {
                    IdTipoFrete?: number
                    EhFreteEspecial?: boolean
                    Descricao?: string
                }[]
            } = {}

            for (let dadosItem of dadosPorItem) {
                tiposFreteDisponiveisPorItem_[dadosItem.identificadorItem] = dadosItem.tiposFretesDisponiveis
            }

            if (isMounted.current) {
                setTiposFreteDisponiveisPorItem(tiposFreteDisponiveisPorItem_)
            }


        } finally {
            atualizarTiposFreteDisponiveisPorItemSendoExecutadoRef.current = false
        }

    }


    const valorParametro = useCallback((nome: string) =>
        parametrosGridItens.find(p => p.Nome === nome)?.Valor,
        [parametrosGridItens]
    );

    const valorParametroPorFilial = useCallback((nome: string) =>
        parametrosGridItensPorFilial.find((p) => p.Nome === nome)?.Valor,
        [parametrosGridItensPorFilial]
    );

    // Função memoizada para obter parâmetros
    const obterParametrosGridItensMemo = useCallback(async () => {
        // Verificar se temos cache válido
        if (parametrosCacheRef.current) {
            return parametrosCacheRef.current;
        }

        try {
            const [parametros, parametrosPorFilial] = await Promise.all([
                obterParametros({ nomes: PARAMETROS_GRID }),
                obterParametrosPorOidItem({
                    nomes: PARAMETROS_POR_FILIAL,
                    oidItem: orcamento.OidFilialOrcamento
                })
            ]);

            // Atualizar cache
            parametrosCacheRef.current = {
                grid: parametros,
                porFilial: parametrosPorFilial
            };

            return parametrosCacheRef.current;
        } catch (error) {
            console.error("Erro ao obter parâmetros:", error);
            return { grid: [], porFilial: [] };
        }
    }, [orcamento.OidFilialOrcamento]);

    const atualizarParametrosGridItens = useCallback(async () => {
        if (!isMounted.current) return;

        try {
            const { grid, porFilial } = await obterParametrosGridItensMemo();

            if (isMounted.current) {
                setParametrosGridItens(grid);
                setParametrosGridItensPorFilial(porFilial);
                setParametrosCarregados(true);
            }
        } catch (error) {
            console.error("Falha ao atualizar parâmetros:", error);
            if (isMounted.current) {
                setParametrosCarregados(false);
            }
        }
    }, [obterParametrosGridItensMemo]);

    // Atualização otimizada de parâmetros.
    // O corpo virou useEffectEvent: ele LÊ orcamento/parametrosCarregados/atualizarParametrosGridItens
    // sempre no valor mais recente, sem que a identidade desses valores dispare o efeito. Antes,
    // `orcamento` e `atualizarParametrosGridItens` estavam nas deps só para o lint, e como o redux
    // troca o objeto `orcamento` a cada atualização, o efeito reexecutava sem necessidade.
    const _carregarParametrosSeNecessario = useEffectEvent(() => {
        if (orcamento && orcamento.OidFilialOrcamento && isMounted.current && !parametrosCarregados) {
            atualizarParametrosGridItens();
        }
    });

    useEffect(() => {
        _carregarParametrosSeNecessario();
    }, [orcamento.OidFilialOrcamento, parametrosCarregados]);

    const atualizarDesativarEdicaoOrdemPedidoCompra = async () => {
        if (!isMounted.current) return
        const possuiPermissao = await microuniversoApi.Orcamento.possuiPermissaoInformarLinhaPedidoCompra(orcamento.IdentificadorOrcamento)
        if (isMounted.current) {
            setDesativarEdicaoOrdemPedidoCompra(!possuiPermissao)
        }
    }

    const obterPermissaoSimulacaoPrecoItem = async () => { // 457575
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "SIMULACAO_PRECO_ITEM")
        if (isMounted.current) {
            setPermitirVisualizarSimulacaoDePreco(permitido)
        }
    }

    const atualizarExibicaoBotaoReservaLote = async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "RESERVAR_LOTES")
        if (isMounted.current) {
            setExibirBotaoReservaLote(permitido)
        }
    }

    const atualizarExibicaoBotaoOrdenarItens = async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "VISUALIZAR_ORDEM_ITEM")
        if (isMounted.current) {
            setExibirBotaoOrdenarItens(permitido)
        }
    }

    const atualizarTamanhoFonte = async () => {

        const tamanho = await microuniversoApi.Orcamento.obterTamanhoFonte()

        if (isMounted.current) {
            setTamanhoFonte(tamanho)
        }
    }


    const atualizarPermiteEngrenagemGrid = async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ACESSO_ENGRENAGEM_GRID")
        if (isMounted.current) {

            setPermiteEngrenagemGrid(permitido)
        }
        
    }
    /*
        const atualizarParametrosGridItens = async () => {
            const parametros = await obterParametrosGridItens()
            const parametrosPorFilial = await obterParametrosPorOidItem({
                nomes: [
                    "TRABALHA_ORDEM_CARGA_ORDEM_ENTREGA_MONTAGEM_CARGA_FATURAMENTO", // 456839
                    "UTILIZA_RECURSO_ENCOMENDA_EXPRESSA",
                    "BLOQUEAR_FATURAMENTO_DIRETO_CLIENTE_RETIRADA_OUTRO_LOCAL", //469010
                    "DESTACAR_PRODUTOS_COM_RETIRADA_CD_ORCAMENTO",
                    "UTILIZA_SERVICO_AGREGADO_ORCAMENTO"
                ],
                oidItem: orcamento.OidFilialOrcamento,
            }) // 43326
    
            if (isMounted.current) {
                setParametrosGridItens(parametros)
                setParametrosGridItensPorFilial(parametrosPorFilial)
                setParametrosCarregados(true)
            }
        }
    */
    const atualizarExibicaoTextoTecnico = async () => {
        const permitido = await permitidoAcaoFuncionalidade(
            "ORCAMENTO_PESQUISAR_PRODUTO",
            "EXIBIR_TEXTO_TECNICO"
        )
        if (isMounted.current) {
            setExibirTextoTecnico(permitido)
        }
    }
/*
    const obterParametrosGridItens = async () => await obterParametros({
        nomes: [
            "CUSTO_PARA_GERAR_MARKUP",
            "UTILIZA_ETIQUETA_PESAGEM_VENDA", // 466531
            "UTILIZA_CONTROLE_PRODUCAO", // nao mudar para "setParametrosGridItensPorFilial"
            "DESTACAR_PRODUTOS_COM_RETIRADA_CD_ORCAMENTO", // nao mudar para "setParametrosGridItensPorFilial"
            "EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO",
            "ACEITAR_PRODUTO_SEM_ESTOQUE",
            "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL",
            "DEFINIR_PREVISAO_ENTREGA_POR_ITEM",
            "APURAR_ST_ORCAMENTO",
            "VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM",
            "ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS",
            "AMBIENTE_ORCAMENTO",
            "AMBIENTE_ORCAMENTO_POR_FILIAL",
            "CHAVE_MOVIMENTACAO_ORCAMENTO",
            "VISUALIZA_MARKUP_PRODUTO_ORCAMENTO",
            "DESABILITAR_PAGINA_ORDEM_SEPARACAO_CONFERENCIA_SAIDA",
            "OFERTA_SELETIVA",
            "EXIBIR_OUTRAS_DESPESAS_ITENS_ORCAMENTO",
            "EXIBIR_COLUNA_ESTOQUE_TOTAL_PRODUTO_VENDAS",
            "CASAS_DECIMAIS_PRECO_VENDA",
            "ORCAMENTO_MASCARA_QUANTIDADE",
            "PERMITIR_OBSERVACAO_POR_ITEM",
            "TRATAR_VENDAS_SOB_ENCOMENDA",
            "TRABALHA_CUPOM_DESCONTO",
            "TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM",
            "PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"
        ]
    })

        const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao })
    */


    const permitidoAcaoFuncionalidade = useCallback(async (siglaFuncionalidade: string, acao?: string): Promise<boolean> => {
        const chave = `${siglaFuncionalidade}:${acao || ''}`;

        // Retorna do cache se existir
        if (cachePermissoesRef.current[chave] !== undefined) {
            return cachePermissoesRef.current[chave];
        }

        // Busca e armazena no cache
        const permitido = await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });
        cachePermissoesRef.current[chave] = permitido;

        return permitido;
    }, []);
    /*
    const limparSelecaoDeItens = () => {
        store.dispatch(desselecionarTodosOsItensAction())
    }
        */
    const limparSelecaoDeItens = useCallback(() => {
        store.dispatch(desselecionarTodosOsItensAction());
    }, []);

    const alterarFonte = useCallback(async (tamanho: number) => {
        if (!isMounted.current) return;
        globalMU.blockUI();
        try {
            await microuniversoApi.Usuario.alterarFonte(nomeGridItens, tamanho);
            if (isMounted.current) {
                limparSelecaoDeItens();
            }
        } catch (e) {
            tratamentoErroPadrao(e);
            if (isMounted.current) {
                limparSelecaoDeItens();
            }
        } finally {
            globalMU.unblockUI();
        }
    }, [limparSelecaoDeItens])

    const atualizarFiliaisRetiradaItem = async (identificadorItem: number) => {
        if (!isMounted.current) return;
        if (!(identificadorItem in filiaisRetiradaPorItem)) {
            const filiaisRetiradaPorItem_ = { ...filiaisRetiradaPorItem }
            filiaisRetiradaPorItem_[identificadorItem] = await obterFiliaisRetiradaItemMemoize()

            if (isMounted.current) {
                setFiliaisRetiradaPorItem(prev => ({
                    ...prev,
                    ...filiaisRetiradaPorItem_
                }))
            }
        }
    }

    const onSimularPrecoItem = (identificadorItem: number) => { // 457575
        if (!isMounted.current) return
        const item = orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem)

        const simuladorPrecoContainerDialog =
            <SimuladorPrecoContainerDialog // 457575
                somenteLeitura={orcamento.SomenteLeitura}
                identificadorOrcamento={orcamento.IdentificadorOrcamento}
                identificadorItem={item.Identificador}
                orcamentoVenda={orcamento.TipoOrcamentoDescricao == "Venda"}
                onAplicar={async () => {
                    const itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(orcamento.IdentificadorOrcamento)
                    window.orcamentoController.model.atualizar(itensTotaisOrcamento)
                    onVoltarGridItens
                }}
                onCancelar={onVoltarGridItens}
            />

        const solicitarSenhaContainer = <SolicitarSenhaContainer // 457575
            passos={passosInterno.current.set("Senha Simulação Preço", () => { onVoltarGridItens() })}
            onVoltar={onVoltarGridItens}
            onRemover={() => { }}
            onSenhaValidada={(senhaValida) => {
                if (senhaValida) renderizarComponentReact(simuladorPrecoContainerDialog, "conteudo-pagina", false)
            }}
            exibirBotaoVoltar={true}
            dicaPermissao="Permissão: [Libera simulação de pesquisa de preços no orçamento]"
            permissao={"TIPO_LIBERACAO_LIBERASIMULACAOPESQUISAORC"} />

        renderizarComponentReact(solicitarSenhaContainer, "conteudo-pagina", true) // 457575
    }

    const atualizarFiliaisTransferenciaItem = useCallback(async (identificadorItem: number) => {
        if (!isMounted.current) return;
        if (!(identificadorItem in filiaisTransferenciaPorItem)) {
            const filiaisTransferenciaPorItem_ = { ...filiaisTransferenciaPorItem }
            filiaisTransferenciaPorItem_[identificadorItem] = await obterFiliaisTransfernciaItem(identificadorItem)

            if (isMounted.current) {
                setFiliaisTransferenciaPorItem(prev => ({
                    ...prev,
                    ...filiaisTransferenciaPorItem_
                }))
            }
        }
    }, [orcamento.IdentificadorOrcamento])
    /*
        const atualizarFiliaisTransferenciaItensQuePossuamFilialModificada = async () => {
            await forEachSeries(orcamento.ItensOrcamento, async item => {
                if (globalMU.isNotNullOrEmpty(item.CodigoFilialTransferencia)) {
                    await atualizarFiliaisTransferenciaItem(item.Identificador)
                }
            })
        }
    **/
    const atualizaDataPrevisaoPrevisaoEntrega = async () => {
        if (!isMounted.current) return
        const data = await microuniversoApi.AgenteDiaUtil.CalcularPrevisaoEntregaOrcamento(orcamento.CodigoFilialOrcamento)
        if (isMounted.current) {
            setDataInicialPrevisaoEntrega(new Date(data))
        }
    }

    // Memoização de valores derivados
    const itensSelecionados = useMemo(() =>
        orcamento?.ItensOrcamento?.filter(i => i.selecionado) || [],
        [orcamento.ItensOrcamento]
    );

    useMenuConsultaProduto(passosInterno.current, () => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true), itensSelecionados.length == 1 ? itensSelecionados[0] : null)

    useEffect(() => () => { isMounted.current = false }, [])

    // Carga inicial da tela: roda uma vez, mas lê props/estado no valor mais recente (useEffectEvent),
    // em vez de ficar preso ao closure da montagem com a lista de deps vazia.
    const _executarCargaInicial = useEffectEvent(() => {
        passosInterno.current.set("Itens", () => { onVoltarGridItens() })

        const executarFuncoes = async () => {
            await Promise.all([
                atualizarPermiteEngrenagemGrid(),
                atualizarTamanhoFonte(),
                //atualizarParametrosGridItens() tem q carregar depois q carregou o orcamento
                atualizarExibicaoBotaoReservaLote(),
                obterPermissaoSimulacaoPrecoItem(), // 457575
                atualizarExibicaoBotaoOrdenarItens(),
                atualizarTiposFaturamento(),
                atualizarDesativarEdicaoOrdemPedidoCompra(),
                atualizaDataPrevisaoPrevisaoEntrega(),
                atualizarExibicaoTextoTecnico(),
                atualizarlistaTipoEntrega(),
            ])
        }

        executarFuncoes()

        if ((props.ehParaRenderizarPesquisaDeProdutosImediatamente?.() ?? false)) {
            itemOrcamentoControllerRef.current.renderizarPesquisaDeProdutosImediatamente = false
            renderizarTelaPesquisaProdutosReact()
            return
        }
    })

    useEffect(() => {
        _executarCargaInicial()
    }, [])

    //456839 - tem que carregar depois do orcamneto para pegar o oid da filial
    const _aoAtualizarOrcamento = useEffectEvent(() => {
        if (orcamento != null && isMounted.current) {

            if (orcamento.NumeroDiasMaximoParaPrevisaoEntrega && orcamento.NumeroDiasMaximoParaPrevisaoEntrega > 0) {
                const dataMaxima = new Date()
                dataMaxima.setDate(dataMaxima.getDate() + orcamento.NumeroDiasMaximoParaPrevisaoEntrega)
                setDataMaximaParaPrevisaoEntrega({ year: dataMaxima.getFullYear(), month: dataMaxima.getMonth() + 1, day: dataMaxima.getDate() })
            }
            atualizarParametrosGridItens()
        }
    })

    useEffect(() => {
        _aoAtualizarOrcamento()
    }, [orcamento])

    const _recarregarColunas = useEffectEvent(() => {
        if (parametrosCarregados && !aguardandoProcessamento && isMounted.current) {
            carregarColunas()
            valorParametro("TRABALHA_CUPOM_DESCONTO") == "S" && carregaProdutosFazemParteCampanhaCupomDesconto()

            atualizarMostrarLocalRetirada()
        }
    })

    useEffect(() => {
        _recarregarColunas()
    }, [orcamento, parametrosGridItens, parametrosGridItensPorFilial, aguardandoProcessamento, parametrosCarregados])

    // `aguardandoProcessamento` e `parametrosCarregados` são LIDOS aqui, mas não disparam o efeito —
    // era exatamente a intenção da lista de deps original, que o lint acusava como incompleta.
    const _atualizarTiposFreteSeLiberado = useEffectEvent(() => {
        if (!aguardandoProcessamento && isMounted.current) {
            atualizarTiposFreteDisponiveisPorItem()
        }
        //itemOrcamentoControllerRef.current.habilitarBotoes()
    })

    useEffect(() => {
        _atualizarTiposFreteSeLiberado()
    }, [orcamento.ItensOrcamento])

    useEffect(() => {
        if (parametrosCarregados) {
            _atualizarTiposFreteSeLiberado()
        }
    }, [parametrosCarregados])

    const _sinalizarAtualizacaoGridItens = useEffectEvent(() => {
        if (!aguardandoProcessamento && isMounted.current) {
            store.dispatch(gridItensActions.atualizarFlagAction())
        }
    })

    useEffect(() => {
        _sinalizarAtualizacaoGridItens()
    }, [totalizadorRedux.ultimaAtualizacao])
    /*
        const carregarColunas = async () => {
            
            setColunas(obterColunas({
                colunasDoCadastroDoUsuario: (await obterColunasGridItens({
                    valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO: valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") as "R" | "C" | "" | null | undefined
                })),
                parametros: parametrosGridItens,
                parametrosPorFilial: parametrosGridItensPorFilial,
                permissaoAcaoMostrarLocalRetirada: await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "MOSTRAR_LOCAL_RETIRADA"),
                permissaoOrcamentoItemVenda: await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "VISUALIZAR_ORDEM_ITEM"),
                orcamento
    
            }))
    
        }
    */
    const carregarColunas = useCallback(async () => {
        if (!isMounted.current) return
        if (!parametrosCarregados) return

        const colunasDoCadastroDoUsuario = await obterColunasGridItens({
            valorParametro_CHAVE_MOVIMENTACAO_ORCAMENTO: valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") as "R" | "C" | "" | null | undefined
        })
        const permissaoAcaoMostrarLocalRetirada = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "MOSTRAR_LOCAL_RETIRADA")
        const permissaoOrcamentoItemVenda = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "VISUALIZAR_ORDEM_ITEM")

        if (!isMounted.current) return

        setColunas(obterColunas({
            colunasDoCadastroDoUsuario,
            parametros: parametrosGridItens,
            parametrosPorFilial: parametrosGridItensPorFilial,
            permissaoAcaoMostrarLocalRetirada,
            permissaoOrcamentoItemVenda,
            orcamento
        }))
    }, [parametrosCarregados, parametrosGridItens, parametrosGridItensPorFilial, orcamento, valorParametro])

    /*
        const atualizarMostrarLocalRetirada = async () => {
            setMostrarLocalRetiradaConsultaItens(
                (await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "MOSTRAR_LOCAL_RETIRADA")) &&
                (orcamento.TipoOrcamentoDescricao == "Venda" || (orcamento.TipoOrcamentoDescricao == "Outras Saídas" && valorParametro("ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL") == "S"))
            )
        }
    */
    const atualizarMostrarLocalRetirada = useCallback(async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "MOSTRAR_LOCAL_RETIRADA")
        if (!isMounted.current) return
        setMostrarLocalRetiradaConsultaItens(
            permitido &&
            (orcamento.TipoOrcamentoDescricao == "Venda" || (orcamento.TipoOrcamentoDescricao == "Outras Saídas" && valorParametro("ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL") == "S"))
        )
    }, [orcamento, valorParametro])


    const atualizarTiposFaturamento = async () => {
        if (!isMounted.current) return
        const tiposFaturamento_ = await microuniversoApi.Orcamento.obterTiposFaturamentoItem()
        if (isMounted.current) {
            setTiposFaturamento(tiposFaturamento_)
        }
    }

    const carregaProdutosFazemParteCampanhaCupomDesconto = async () => {
        if (!isMounted.current) return
        const produtosOrcamento = store.getState()?.orcamento.ItensOrcamento.map(i => i.CodigoProduto)
        const cuponsOrcamento = store.getState()?.orcamento?.CuponsDescontoSelecionados?.map(i => i.Id)

        const resultado = await verificaProdutosFazemParteCampanhasDesconto(cuponsOrcamento, produtosOrcamento)

        if (!isMounted.current) return
        setProdutosFazemParteCampanhaCupomDesconto(resultado?.CodigosProdutosFazemParteCamapanhaDesconto ?? [])
    }

    const definirTipoFaturamento = async (tipoFaturamento, identificadorItem) => {
        globalMU.blockUI()
        try {
            await definirTipoFaturamentoItem({
                tipoFaturamento,
                identificadorItem
            })
            limparSelecaoDeItens()
            globalMU.unblockUI()
        } catch (e) {
            tratamentoErroPadrao(e)

            limparSelecaoDeItens()
            globalMU.unblockUI()
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const atualizarlistaTipoEntrega = async () => {
        if (!isMounted.current) return

        globalMU.blockUI();
        try {
            const tiposEntrega_ = await microuniversoApi.Orcamento.listarTipoEntrega();
            if (isMounted.current) {
                setTiposEntrega(tiposEntrega_);
            }
        } catch (erro) {
            tratamentoErroPadrao(erro);
        } finally {
            globalMU.unblockUI()
        }
    };
    /*
        const alterarQuantidadeItem = async (identificadorItem: number, quantidade: number) => {
            globalMU.blockUI({ tryPassiveLoading: true })
            const item = orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem)
    
            const dadosExibicaoModalVendaSobEncomendaItemAnterior: DadosParaAvaliarExibicaoModalVendaSobEncomenda = {
                VendaSobEncomenda: item.VendaSobEncomenda,
                CodigoFilialRetirada: item.CodigoFilialRetirada,
                CodigoTipoEntrega: item.CodigoTipoEntrega,
                Quantidade: item.Quantidade
            }
    
            try {
                await alterarQuantidadeItemUseCase({
                    identificadorItem,
                    quantidade,
                    quantidadeEstoque: item.QuantidadeEstoque,
                    quantidadeSolicitada: item.QuantidadeSolicitada,
                    atualizarEstadoLegadoImediatamente: true,
                    silent: true
                })
    
                limparSelecaoDeItens()
                globalMU.unblockUI()
    
                const dadosExibicaoModalVendaSobEncomendaItemAtual = R.pipe(
                    item => ({
                        VendaSobEncomenda: item.VendaSobEncomenda,
                        CodigoFilialRetirada: item.CodigoFilialRetirada,
                        CodigoTipoEntrega: item.CodigoTipoEntrega,
                        Quantidade: item.Quantidade
                    } as DadosParaAvaliarExibicaoModalVendaSobEncomenda)
                )(store.getState().orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem))
    
                if (ehNecessarioMostrarModalVendaSobEncomenda({
                    dadosItemAnterior: dadosExibicaoModalVendaSobEncomendaItemAnterior,
                    dadosItemAtual: dadosExibicaoModalVendaSobEncomendaItemAtual
                })) {
                    setDadosModalVendaSobEncomenda({
                        mostrar: true,
                        identificadorItem: identificadorItem,
                        solicitacaoManual: false
                    })
                }
    
            } catch (erro) {
                tratamentoErroPadrao(erro)
                limparSelecaoDeItens()
                globalMU.unblockUI()
            }
            finally {
                globalMU.unblockUI()
            }
    
        }
    */
    const alterarQuantidadeItem = useCallback(async (identificadorItem: number, quantidade: number) => {
        globalMU.blockUI({ tryPassiveLoading: true });

        // 1. Obter item diretamente do estado do Redux
        const state = store.getState();
        const item = state.orcamento.ItensOrcamento.find(i => i.Identificador === identificadorItem);
        if (!item) return;

        // 2. Guardar estado anterior simplificado
        const dadosAnteriores = {
            VendaSobEncomenda: item.VendaSobEncomenda,
            CodigoFilialRetirada: item.CodigoFilialRetirada,
            CodigoTipoEntrega: item.CodigoTipoEntrega,
            Quantidade: item.Quantidade
        };

        try {
            // 3. Atualizar quantidade
            await alterarQuantidadeItemUseCase({
                identificadorItem,
                quantidade,
                quantidadeEstoque: item.QuantidadeEstoque,
                quantidadeSolicitada: item.QuantidadeSolicitada,
                atualizarEstadoLegadoImediatamente: true,
                silent: true
            });

            if (!isMounted.current) return

            // 4. Obter novo estado diretamente do Redux
            const novoState = store.getState();
            const novoItem = novoState.orcamento.ItensOrcamento.find(i => i.Identificador === identificadorItem);

            // 5. Verificar necessidade do modal
            if (novoItem && ehNecessarioMostrarModalVendaSobEncomenda({
                dadosItemAnterior: dadosAnteriores,
                dadosItemAtual: {
                    VendaSobEncomenda: novoItem.VendaSobEncomenda,
                    CodigoFilialRetirada: novoItem.CodigoFilialRetirada,
                    CodigoTipoEntrega: novoItem.CodigoTipoEntrega,
                    Quantidade: novoItem.Quantidade
                }
            })) {
                setDadosModalVendaSobEncomenda({
                    mostrar: true,
                    identificadorItem,
                    solicitacaoManual: false
                });
            }
        } catch (erro) {
            tratamentoErroPadrao(erro);
        } finally {
            limparSelecaoDeItens();
            globalMU.unblockUI();
        }
    }, [alterarQuantidadeItemUseCase, ehNecessarioMostrarModalVendaSobEncomenda, globalMU, limparSelecaoDeItens]);

    const alterarPrecoItem = async (identificadorItem: number, preco: number, percentualDesconto: number, percentualBonificacao: number,) => {
        globalMU.blockUI({ tryPassiveLoading: true })

        try {
            await alterarPrecoItemUseCase({
                identificadorItem, preco, percentualDesconto, percentualBonificacao, atualizarEstadoLegadoImediatamente: true,
                silent: true
            })
            limparSelecaoDeItens()
            globalMU.unblockUI()


        } catch (erro) {
            tratamentoErroPadrao(erro)
            limparSelecaoDeItens()
            globalMU.unblockUI()

        }
        finally {
            globalMU.unblockUI()
        }

    }

    const alterarPorcentagemDescontoUnitario = async (identificadorItem: number, preco: number, percentualDescontoUnitario: number, preservaDesconto: boolean) => {
        globalMU.blockUI()

        try {
            const dados = await simularDescontoItem({
                percentualDesconto: percentualDescontoUnitario,
                preco: null,
                preservaDescontoModificadoManualmente: false,
                preservaDesconto: true,
                precoUnitarioTabela: preco,
                identificadorItem: identificadorItem,
                identificadorOrcamento: orcamento.IdentificadorOrcamento,
                percentualBonificacao: 0,
                percentualDescontoOrcamento: orcamento.PercentualDesconto,

            })


            await alterarPrecoItemUseCase({
                identificadorItem: identificadorItem,
                preco: dados.Preco,
                percentualDesconto: percentualDescontoUnitario,
                percentualBonificacao: 0,
                PARAMETRO_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO: valorParametro("PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"),
                preservaDesconto: dados.PreservaDesconto
            })

            globalMU.unblockUI()


        } catch (erro) {
            tratamentoErroPadrao(erro)
            globalMU.unblockUI()
        }
    }

    const alterarPreservarDescontoUnitario = async (identificadorItem: number, preco: number, percentualDescontoUnitario: number, preservarDescontoUnitario: boolean) => {
        globalMU.blockUI()

        try {

            await alterarPrecoItemUseCase({
                identificadorItem: identificadorItem,
                preco: preco,
                percentualDesconto: percentualDescontoUnitario,
                percentualBonificacao: 0,
                PARAMETRO_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO: valorParametro("PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"),
                preservaDesconto: preservarDescontoUnitario
            })

            globalMU.unblockUI()


        } catch (erro) {
            tratamentoErroPadrao(erro)
            globalMU.unblockUI()
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const alterarPercentualMarkupItem = async (identificadorItem: number, percentualMarkup: number) => {
        globalMU.blockUI()
        try {
            await alterarPercentualMarkupItemUseCase({
                identificadorItem,
                percentualMarkup
            })


        } catch (erro) {
            tratamentoErroPadrao(erro)
            limparSelecaoDeItens()
            globalMU.unblockUI()
        }
        finally {
            globalMU.unblockUI()
        }
    }
    /*
        const onFilialRetiradaAlterada = async (codigoFilialRetirada: string, identificadorItem: number) => {
            globalMU.blockUI()
            try {
    
                const dadosExibicaoModalVendaSobEncomendaItemAnterior: DadosParaAvaliarExibicaoModalVendaSobEncomenda = R.pipe(
                    item => ({
                        VendaSobEncomenda: item.VendaSobEncomenda,
                        CodigoFilialRetirada: item.CodigoFilialRetirada,
                        CodigoTipoEntrega: item.CodigoTipoEntrega,
                        Quantidade: item.Quantidade
                    })
                )(store.getState().orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem))
    
                await definirFilialRetiradaItem({
                    identificadorItem,
                    codigoFilialRetirada
                })
                
                setFiliaisTransferenciaPorItem(R.omit([`${identificadorItem}`], filiaisTransferenciaPorItem))
                
                limparSelecaoDeItens()
                globalMU.unblockUI()
    
                const dadosExibicaoModalVendaSobEncomendaItemAtual: DadosParaAvaliarExibicaoModalVendaSobEncomenda = R.pipe(
                    item => ({
                        VendaSobEncomenda: item.VendaSobEncomenda,
                        CodigoFilialRetirada: item.CodigoFilialRetirada,
                        CodigoTipoEntrega: item.CodigoTipoEntrega,
                        Quantidade: item.Quantidade
                    })
                )(store.getState().orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem))
    
                if (ehNecessarioMostrarModalVendaSobEncomenda({
                    dadosItemAnterior: dadosExibicaoModalVendaSobEncomendaItemAnterior,
                    dadosItemAtual: dadosExibicaoModalVendaSobEncomendaItemAtual
                })) {
                    setDadosModalVendaSobEncomenda({
                        mostrar: true,
                        identificadorItem: identificadorItem,
                        solicitacaoManual: false
                    })
                }
    
            } catch (e) {
                
                tratamentoErroPadrao(e)
                limparSelecaoDeItens()
                globalMU.unblockUI()
            }
            finally {
                globalMU.unblockUI()
            }
        }
    */
    const onFilialRetiradaAlterada = useCallback(async (codigoFilialRetirada: string, identificadorItem: number) => {
        globalMU.blockUI();

        // 1. Obter estado atual do Redux
        const state = store.getState();
        const item = state.orcamento.ItensOrcamento.find(i => i.Identificador === identificadorItem);
        if (!item) return;

        // 2. Guardar estado anterior simplificado
        const dadosAnteriores = {
            VendaSobEncomenda: item.VendaSobEncomenda,
            CodigoFilialRetirada: item.CodigoFilialRetirada,
            CodigoTipoEntrega: item.CodigoTipoEntrega,
            Quantidade: item.Quantidade
        };

        try {
            // 3. Atualizar filial
            await definirFilialRetiradaItem({ identificadorItem, codigoFilialRetirada });

            if (!isMounted.current) return

            // 4. Atualizar cache de forma funcional
            setFiliaisTransferenciaPorItem(prev => R.omit([`${identificadorItem}`], prev));

            // 5. Obter novo estado do Redux
            const novoState = store.getState();
            const novoItem = novoState.orcamento.ItensOrcamento.find(i => i.Identificador === identificadorItem);

            // 6. Verificar necessidade do modal
            if (novoItem && ehNecessarioMostrarModalVendaSobEncomenda({
                dadosItemAnterior: dadosAnteriores,
                dadosItemAtual: {
                    VendaSobEncomenda: novoItem.VendaSobEncomenda,
                    CodigoFilialRetirada: novoItem.CodigoFilialRetirada,
                    CodigoTipoEntrega: novoItem.CodigoTipoEntrega,
                    Quantidade: novoItem.Quantidade
                }
            })) {
                setDadosModalVendaSobEncomenda({
                    mostrar: true,
                    identificadorItem,
                    solicitacaoManual: false
                });
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            limparSelecaoDeItens();
            globalMU.unblockUI();
        }
    }, [definirFilialRetiradaItem, ehNecessarioMostrarModalVendaSobEncomenda, globalMU, limparSelecaoDeItens]);
    const onFilialTransferenciaAlterada = async (codigoFilialTransferencia: string, identificadorItem: number) => {
        globalMU.blockUI()
        try {
            await definirFilialTransferenciaItem({
                identificadorItem,
                codigoFilialTransferencia
            })
            limparSelecaoDeItens()
            globalMU.unblockUI()
        } catch (e) {
            tratamentoErroPadrao(e)
            limparSelecaoDeItens()
            globalMU.unblockUI()
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const editarPedidoCompra = async (identificadorItem: number, pedidoDeCompra: string) => {
        await definirPedidoDeCompraItem({
            identificadorItem,
            pedidoDeCompra
        })


    }

    const editarLinhaOrdemPedidoCompraItem = async (identificadorItem: number, linhaOrdemCompra: string) => {
        await alterarOrdemPedidoCompraItem({
            identificadorItem,
            linhaOrdemPedidoCompra: linhaOrdemCompra
        })


    }

    const atualizarEOuInformarCentroCusto = async (nomeParcial: string, identificadorItem: number) => {
        if (!isMounted.current) return
        if (globalMU.isNullOrEmpty(nomeParcial)) {
            await definirCentroCustoItem({
                idCentroCusto: null,
                identificadorItem
            })

            return
        }

        const centrosCusto_ = await microuniversoApi.Orcamento.obterCentroCusto(
            orcamento.IdentificadorOrcamento,
            nomeParcial
        )

        if (centrosCusto_.length == 1 && centrosCusto_[0].NomeCentroCusto.trim() == nomeParcial) {
            await definirCentroCustoItem({
                idCentroCusto: centrosCusto_[0].IdClienteCentroCusto,
                identificadorItem
            })

            if (isMounted.current) {
                setCentrosCusto([])
            }
        } else if (isMounted.current) {
            setCentrosCusto(centrosCusto_)
        }



    }


    const toggleColunaSelecionada = async (nomeColuna: string, selecionada: boolean) => {
        if (!isMounted.current) return
        let coluna = { ...colunas.find(c => c.Nome == nomeColuna) }
        coluna.Selecionada = selecionada

        const colunas_ = substituirItemEmArray(colunas, coluna => coluna.Nome == nomeColuna, coluna)

        setColunas(colunas_)
        store.dispatch(colunasGridOrcamentoActions.atualizar(colunas_))

        if (coluna.ehEstoqueFilial) {
            await microuniversoApi.Seguranca.atualizarGridEhEstoque({
                CodigoUsuario: globalMU.userIdForGrid(),
                Modulo: "Orcamento",
                Token: globalMU.token(),
                /*
                NomeGrid: "ITENS_ORCAMENTO",
                */
                NomeGrid: nomeGridItens,
                Colunas: colunas_.filter(c => c.ehEstoqueFilial)
            })
            //store.dispatch(sobrescreverInformacoesAction({...orcamento}))
        } else {
            await microuniversoApi.Seguranca.atualizarGrid({
                CodigoUsuario: globalMU.userIdForGrid(),
                Modulo: "Orcamento",
                Token: globalMU.token(),
                /*
                NomeGrid: "ITENS_ORCAMENTO",
                */
                NomeGrid: nomeGridItens,
                Colunas: colunas_.filter(c => !c.ehEstoqueFilial)
            })
        }

    }

    const toggleColunaSelecionadaConsultarItens = async (nomeColuna: string, selecionada: boolean) => {
        if (!isMounted.current) return
        let coluna = { ...colunasConsultarItens.find(c => c.Nome == nomeColuna) }
        coluna.Selecionada = selecionada

        const colunas_ = substituirItemEmArray(colunasConsultarItens, coluna => coluna.Nome == nomeColuna, coluna)

        setColunasConsultarItens(colunas_)

        if (coluna.ehEstoqueFilial) {
            await microuniversoApi.Seguranca.atualizarGridEhEstoque({
                CodigoUsuario: globalMU.userIdForGrid(),
                Modulo: "Orcamento",
                Token: globalMU.token(),
                /*
                NomeGrid: "CONSULTAR_ITENS_ORCAMENTO",
                */
                NomeGrid: nomeGridConsultaItens,
                Colunas: colunas_.filter(c => c.ehEstoqueFilial)
            })
        } else {
            await microuniversoApi.Seguranca.atualizarGrid({
                CodigoUsuario: globalMU.userIdForGrid(),
                Modulo: "Orcamento",
                Token: globalMU.token(),
                /*
                NomeGrid: "CONSULTAR_ITENS_ORCAMENTO",
                */
                NomeGrid: nomeGridConsultaItens,
                Colunas: colunas_.filter(c => !c.ehEstoqueFilial)
            })
        }
    }

    const toggleSelecionarTodasColunas = async (selecionar: boolean) => {
        if (!isMounted.current) return
        const colunas_ = colunas.map(c => ({ ...c, Selecionada: selecionar } as IColuna))
        setColunas(colunas_)
        store.dispatch(colunasGridOrcamentoActions.atualizar(colunas_))

        await microuniversoApi.Seguranca.atualizarGrid({
            CodigoUsuario: globalMU.userIdForGrid(),
            Modulo: "Orcamento",
            Token: globalMU.token(),
            /*
            NomeGrid: "ITENS_ORCAMENTO",
            */
            NomeGrid: nomeGridItens,
            Colunas: colunas_
        })

    }

    const toggleSelecionarTodasColunasConsultarItens = async (selecionar: boolean) => {
        if (!isMounted.current) return
        const colunas_ = colunasConsultarItens.map(c => ({ ...c, Selecionada: selecionar } as IColuna))
        setColunasConsultarItens(colunas_)

        await microuniversoApi.Seguranca.atualizarGrid({
            CodigoUsuario: globalMU.userIdForGrid(),
            Modulo: "Orcamento",
            Token: globalMU.token(),
            /*
            NomeGrid: "CONSULTAR_ITENS_ORCAMENTO",
            */
            NomeGrid: nomeGridConsultaItens,
            Colunas: colunas_
        })
    }

    const excluirItens = async (itens: IItemOrcamento[]) => {
        globalMU.blockUI()

        // Calculado ANTES de excluir: depois da exclusao os itens ja sairam de
        // orcamento.ItensOrcamento e nao daria mais para saber quem era o vizinho.
        const identificadoresAncoraScroll = _obterIdentificadoresAncoraScroll(orcamento.ItensOrcamento ?? [], itens)

        try {
            await excluirItensUseCase({ itens })
            limparSelecaoDeItens()
            _reposicionarScrollGridNaLinha(identificadoresAncoraScroll)
            globalMU.unblockUI()
        } catch (e) {
            tratamentoErroPadrao(e)
            limparSelecaoDeItens()
        } finally {
            globalMU.unblockUI()
        }
    }

    const adicionarProdutoPorCodigoOuReferencia = async (codigoOuReferencia: string, somarQuantidadeProdutoRepetido?: boolean) => { // 491040
        if (!isMounted.current) return
        globalMU.blockUI()

        try {
            let resultadoPesquisa = await microuniversoApi.Produto.pesquisarProdutoUnico(codigoOuReferencia, orcamento.IdentificadorOrcamento, somarQuantidadeProdutoRepetido) // 491040

            if (!("Error" in resultadoPesquisa)) {
                let podeSerAdicionado = false
                let mensagensValidacao = [];

                if (resultadoPesquisa?.Entities?.length > 1 && (resultadoPesquisa?.Entities ?? []).filter(x => x.Referencia.trimEnd() == codigoOuReferencia).length != 1) {
                    mensagensValidacao = ["A pesquisa retornou mais de um resultado, não será possível adicionar o produto automaticamente"]
                } else {

                    resultadoPesquisa = {
                        ...resultadoPesquisa,
                        Entities: resultadoPesquisa?.Entities?.length == 1 ? resultadoPesquisa.Entities :
                            (resultadoPesquisa?.Entities ?? []).filter(x => parametrosGridItens.find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor == "C" ?
                                x.Codigo.trimEnd() == codigoOuReferencia : x.Referencia.trimEnd() == codigoOuReferencia)
                    }

                    const resultadoValidacao = produtoPodeSerAdicionadoAutomaticamenteAoOrcamento(
                        resultadoPesquisa?.Entities?.[0],
                        orcamento,
                        true,
                        true)

                    podeSerAdicionado = resultadoValidacao.podeSerAdicionado
                    mensagensValidacao = resultadoValidacao.mensagensValidacao;
                }

                if (podeSerAdicionado) {
                    const respostaInsercaoProdutos = await adicionarProdutos(orcamento.IdentificadorOrcamento, (resultadoPesquisa?.Entities ?? []))

                    if (respostaInsercaoProdutos.status == "SUCESSO" && (mensagensValidacao ?? []).length == 0) {
                        globalMU.showSuccessMessage("Item adicionado com sucesso")
                    }
                }

                await forEachSeries((mensagensValidacao ?? []), mensagem => new Promise<void>(resolve => {
                    setTimeout(() => {
                        globalMU.showWarnMessage(mensagem)
                        resolve()
                    }, 500)
                }))

                if (!isMounted.current) return

                setLimparCodigoOuReferenciaFlag(uuidv4())

                const foiIncluidoItemMadeira = (store.getState().orcamento.ItensOrcamento ?? []).some(i => i.Madeira && i.DadosMadeira == null)
                if (foiIncluidoItemMadeira) {
                    renderizarComponentReact(
                        <TratamentoMadeiraContainer
                            onCancelar={() => renderizarComponentReact(
                                <ItensOrcamentoContainer />,
                                "conteudo-pagina",
                                true
                            )}
                            onFinalizarConfiguracaoProdutos={() => renderizarComponentReact(
                                <ItensOrcamentoContainer />,
                                "conteudo-pagina",
                                true
                            )}
                            somenteLeitura={orcamento.SomenteLeitura}
                        />,
                        "conteudo-pagina",
                        true
                    )
                }
            }
        } catch (e) {
            tratamentoErroPadrao(e)

        } finally {
            limparSelecaoDeItens()
            globalMU.unblockUI()
        }
    }

    const alterarTipoEntrega = async (tipoEntrega: "C" | "E" | "F") => {
        globalMU.blockUI()
        try {
            globalMU.blockScreen()
            const resultadoAlteracao = await alterarTipoEntregaItens(
                {
                    tipoEntrega,
                    itens: itensSelecionados,
                    alterarTipoEntregaPadraoOrcamento: false // 474918
                })
            store.dispatch(desselecionarTodosOsItensAction())
            limparSelecaoDeItens()

            if (resultadoAlteracao.status == "SUCESSO") {
                globalMU.showSuccessMessage("Tipo de entrega alterado com sucesso")
            }
            else // 477409
            {
                const itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(orcamento.IdentificadorOrcamento) // 477409
                window.orcamentoController.model.atualizar(itensTotaisOrcamento)// 477409
            }

        } catch (e) {
            tratamentoErroPadrao(e)
            limparSelecaoDeItens()
        } finally {
            globalMU.unblockUI()
            globalMU.unblockScreen()
        }
    }

    const onDataPrevistaAlterado = async (dataPrevisaoEntrega: DataFormatoEN, identificadorItem: number) => {
        globalMU.blockUI();
        try {
            await alterarDataPrevisaoEntregaItem({ identificadorItem, dataPrevisaoEntrega });

        } catch (e) {
            tratamentoErroPadrao(e);

        } finally {
            globalMU.unblockUI()
        }
    };

    const onDataMarcadaAlterado = async (dataMarcadaEntrega: string, identificadorItem: number) => {
        globalMU.blockUI();
        try {
            await alterarDataMarcadaEntregaItem({
                identificadorItem,
                dataMarcadaEntrega
            });

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI()
        }
    };

    const onTipoEntregaAlterada = async (codigoTipoEntrega: CodigoTipoEntrega, identificadorItem: number) => {
        globalMU.blockUI();
        try {
            await alterarTipoEntregaItem({
                identificadorItem: identificadorItem,
                codigoTipoEntrega: codigoTipoEntrega,
                itemOrcamento: (orcamento.ItensOrcamento ?? []).find(i => i.Identificador == identificadorItem)
            });


        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI()
        }
    };


    const onAlterarEntregaPosteriorItens = async (check?: boolean, item?: IItemOrcamento) => {
        globalMU.blockUI()
        try {
            globalMU.blockScreen()
            if (item?.VendaSobEncomenda && item?.EntregaPosterior) return
            /*
            const resultadoAlteracao = await alterarEntregaPosteriorItens({
                itens: item ? [item] : (orcamento.ItensOrcamento ?? []).filter(i => i.selecionado == true),
                check: check
            })
                */
            const resultadoAlteracao = await alterarEntregaPosteriorItens({
                itens: item ? [item] : itensSelecionados,
                check: check
            })

            store.dispatch(desselecionarTodosOsItensAction())
            limparSelecaoDeItens()

            if (resultadoAlteracao.status == "SUCESSO") {
                globalMU.showSuccessMessage("Entrega posterior alterado com sucesso")
            }

        } catch (e) {
            tratamentoErroPadrao(e)
            limparSelecaoDeItens()
        } finally {
            globalMU.unblockUI()
            globalMU.unblockScreen()
        }
    }

    const onAlterarMostruario = async (check: boolean, item: IItemOrcamento) => { // PA 487087
        globalMU.blockUI()
        try {
            await alterarMostruarioItem({ item, check })
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onTurnoEntregaAlterado = async (turnoEntrega: CodigoTurnoEntrega, identificadorItem: number) => {
        globalMU.blockUI();

        try {
            await alterarTurnoEntregaItem({
                identificadorItem,
                turnoEntrega
            });

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI()
        }
    };

    const reordenarItens = async (itens: IItemOrcamento[]) => {
        try {
            globalMU.blockUI()
            await reordenarOrcamento({ itens })
            limparSelecaoDeItens()
        } catch (e) {
            tratamentoErroPadrao(e)
            limparSelecaoDeItens()
        } finally {
            globalMU.unblockUI()
        }
    }

    const excluirAmbiente = async (ambiente: Ambiente, identificador: number) => {
        /*
        const itensSelecionados = (orcamento.ItensOrcamento ?? []).filter(i => i.selecionado == true)
        */
        await editarAmbiente({
            nome: null,
            identificadorItens: itensSelecionados.map(i => i.Identificador).concat(identificador)
        })

        const algumItemPossuiEstaCor = () => obterAmbientesPelosItens().find(a => a.cor == ambiente.cor) != null

        store.dispatch(atualizarItemAction({ identificador, dados: { CorAmbiente: null } }))

        if (!algumItemPossuiEstaCor()) {
            store.dispatch(desassociarCorAction({ ambiente: ambiente.nome, cor: ambiente.cor }))
        }

    }

    const alterarAmbienteItem = async (ambiente: Ambiente, identificador: number) => {
        /*
        const itensSelecionados = (orcamento.ItensOrcamento ?? []).filter(i => i.selecionado == true)
        */

        await editarAmbiente({
            identificadorItens: itensSelecionados.map(i => i.Identificador).concat(identificador),
            nome: ambiente?.nome || null
        })

        store.dispatch(atualizarItemAction({ identificador, dados: { CorAmbiente: ambiente.cor } }))
        store.dispatch(associarCorAction({ ambiente: ambiente.nome, cor: ambiente.cor }))

        setToggleLimparNovoAmbiente(uuidv4())
    }
    /*
        const definirDespesasInclusasItensSelecionados = async () => {
            await forEachSeries((orcamento.ItensOrcamento ?? []).filter(i => i.selecionado),
                item => definirDespesasInclusasParaItemOrcamento({
                    identificadorItem: item.Identificador,
                    ativado: !item.DespesasInclusas
                }))
        }
    */
    const definirDespesasInclusasItensSelecionados = async () => {
        await forEachSeries(itensSelecionados,
            item => definirDespesasInclusasParaItemOrcamento({
                identificadorItem: item.Identificador,
                ativado: !item.DespesasInclusas
            }))
    }

    const onRetornoPesquisarCor = async (codigoCorSelecionada: number, identificadorItem: number) => { // PA 402355 repasse 311033
        if (!isMounted.current) return
        globalMU.blockUI()
        try {
            const itensTotaisOrcamento = await microuniversoApi.Orcamento.DefinirIdCorTintometricoSimplificado(orcamento.IdentificadorOrcamento, identificadorItem, codigoCorSelecionada)
            store.dispatch(atualizarItemAction(
                { identificador: identificadorItem, dados: { IdCorTintometricoSimplicado: codigoCorSelecionada } }
            ))
            if (itensTotaisOrcamento.HasErrors != true)
                window.orcamentoController.model.atualizar(itensTotaisOrcamento)
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
        onVoltarGridItens()
    }
    const onTipoEntregaPadraoOrcamento = async (tipoEntrega: "T" | "C" | "E" | "F") => // 474918
    {
        if (!isMounted.current) return

        globalMU.blockUI()
        try {
            const tipoEntregaPadrao = tipoEntrega == "T" ? "" : tipoEntrega
            const resultadoAlteracao = await alterarTipoEntregaItens(
                {
                    tipoEntrega: tipoEntregaPadrao,
                    itens: null,
                    alterarTipoEntregaPadraoOrcamento: true // 474918
                })
            store.dispatch(desselecionarTodosOsItensAction())
            limparSelecaoDeItens()

            if (resultadoAlteracao.status == "SUCESSO") {
                if (tipoEntrega == "T" || globalMU.isNullOrEmpty(tipoEntrega))
                    globalMU.showSuccessMessage("Tipo de entrega padrão alterado com sucesso")
                else
                    globalMU.showSuccessMessage("Tipo de entrega alterado com sucesso")
            }
            else // 477409
            {
                const itensTotaisOrcamento = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(orcamento.IdentificadorOrcamento) // 477409
                window.orcamentoController.model.atualizar(itensTotaisOrcamento)// 477409
            }

        } catch (e) {
            tratamentoErroPadrao(e)
            limparSelecaoDeItens()
            globalMU.unblockUI()
        } finally {
            globalMU.unblockUI()
        }
    }

    const onAlterarObservacao = async (obs, item) => {
        if (!isMounted.current) return
        globalMU.blockUI()
        try {
            const observacaoDefinida = await microuniversoApi.Orcamento.definirObservacaoItemOrcamento(orcamento.IdentificadorOrcamento, item.Identificador, obs)
            store.dispatch(atualizarItemAction(
                { identificador: item.Identificador, dados: { ObservacaoDoItem: observacaoDefinida } }
            ))
        } catch (e) {
            tratamentoErroPadrao(e)
            globalMU.unblockUI()
        } finally {
            globalMU.unblockUI()
        }
    }
    /*
        const obterNumeroCasasDecimaisQuantidade = () => globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(valorParametro("ORCAMENTO_MASCARA_QUANTIDADE"), 3
        )
    */
    const obterNumeroCasasDecimaisQuantidade = useCallback(() =>
        globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(valorParametro("ORCAMENTO_MASCARA_QUANTIDADE"), 3),
        [valorParametro]
    )

    const onAlterarDataEntregaSelecionados = async (data: DataFormatoEN, itensSelecionados: IItemOrcamento[]) => {
        try {
            globalMU.blockUI()
            globalMU.blockScreen()

            await alterarDataPrevisaoEntregaItens({
                dataPrevisaoEntrega: data,
                identificadoresItens: itensSelecionados.map(i => i.Identificador)
            })


        } finally {
            globalMU.unblockUI()
            globalMU.unblockScreen()
        }
    }

    const validarExisteOrdemItemRepetido = () => {
        let retorno = false
        for (let item of orcamento.ItensOrcamento) {
            if (item.Classe.toLowerCase() != "itempedidovendasubordinado") {
                let itemRepetido = orcamento.ItensOrcamento?.find((itemOrcamento) => itemOrcamento.OrdemItem == item.OrdemItem
                    && itemOrcamento.Identificador != item.Identificador
                    && itemOrcamento.Classe.toLowerCase() != "itempedidovendasubordinado"
                )
                if (itemRepetido) {
                    globalMU.showErrorMessage("Existe mais de um item com ordem [" + itemRepetido.OrdemItem + "]")
                    retorno = true
                    break
                }
            }
        }
        return retorno
    }

    const alterarPrioridadeMontagem = async (prioridadeMontagem: boolean, identificadorItem: number) => {
        try {
            await definirPrioridadeMontagemItem({ identificadorItem, prioridadeMontagem }); // 456839
        }
        catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const alterarEncomendaExpressa = async (encomendaExpressa: boolean, identificadorItem: number) => {
        try {
            await definirEncomendaExpressaItem({ identificadorItem, encomendaExpressa }); // 433263
        } finally {
            globalMU.unblockUI()
        }
    }

    const alterarVendaSobEncomenda = async (vendaSobEncomenda: boolean, identificadorItem: number) => {
        if (!isMounted.current) return
        try {
            await definirVendaSobEncomendaItem({
                identificadorItem,
                vendaSobEncomenda,
            });

            if (!isMounted.current) return

            if (globalMU.isNotNullOrEmpty(valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA")) && valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") != "4") {
                if (vendaSobEncomenda) {
                    setDadosModalVendaSobEncomenda({
                        identificadorItem,
                        mostrar: vendaSobEncomenda,
                        solicitacaoManual: true
                    })
                }
            }
        }
        catch (e) {
            tratamentoErroPadrao(e)

        } finally {
            globalMU.unblockUI()
        }
    }

    const mostrarModalEncomenda = (data, item) => {
        // if (data && item.VendaSobEncomenda) {
        //     const modalVendaSobEncomendaDialog = <ModalVendaSobEncomendaDialog
        //         Item={item}
        //         Produto={data.Produto}
        //         Quantidade={data.Quantidade}
        //         QuantidadeEstoque={data.QuantidadeEstoque}
        //         QuantidadeReservada={data.QuantidadeReservada}
        //         QuantidadeDisponivel={data.QuantidadeDisponivel}
        //         QuantidadeReservadaPedido={data.QuantidadeReservadaPedido}
        //         QuantidadeDisponivelPedido={data.QuantidadeDisponivelPedido}
        //         QuantidadePedidosCompra={data.QuantidadePedidosCompra}
        //         PrazoEntregaFornecedor={data.PrazoEntregaFornecedor}
        //         HabilitarAdquirirQuantidadeTotalItem={habilitarAdquirirQuantidadeTotalItem(data, item)}
        //         AdquirirQuantidadeTotalItem={data.adquirirQuantidadeTotalItem}
        //         onAdquirirQuantidadeTotalItem={(adquirirQuantidadeTotal) => adquirirQuantidadeTotalAlterado(adquirirQuantidadeTotal, item)}
        //         onAlterarVendaSobEncomenda={(check, identificadorItem, item) => alterarVendaSobEncomenda(check, identificadorItem, item)}
        //     />

        //     renderizarComponentReact(modalVendaSobEncomendaDialog, "conteudo-pagina", false)
        // }
    }


    const onVoltarGridItens = () => {
        //490305 -> aqui nao pode  isso -> if (!isMounted.current) return

        renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)
    }
    /*
        const renderizarTelaPesquisaProdutos = () => {
            if (!isMounted.current) return
            itemOrcamentoControllerRef.current.showView({
                acaoParaComponenteReact: "REMOVER",
                region: {
                    name: "pesquisarProdutosRegion",
                    selector: "#pesquisar-produtos-container"
                },
                controller: {
                    type: PesquisarProdutosController,
                    args: {
                        model: window.orcamentoController.model,
                        orcamento: window.orcamentoController.model,
                        // adicionarProdutosCallback: this.adicionarProdutos.bind(this),
                        adicionarProdutosCallback: itemOrcamentoControllerRef.current.adicionarProdutos2.bind(itemOrcamentoControllerRef.current),
                        itensAdicionadosCallback: itemOrcamentoControllerRef.current.itensAdicionados.bind(itemOrcamentoControllerRef.current),
                        readOnly: itemOrcamentoControllerRef.current.readOnly,
                        //renderizadoCallback: $.proxy(itemOrcamentoControllerRef.pesquisarProdutoRenderizado, this)
                    }
                }
    
            })
        }
    */
    const renderizarTelaPesquisaProdutosReact = (chamadoPeloTrocarProduto: boolean = false) => {
        if (!isMounted.current) return
        renderizarComponentReact(
            <PaginaPesquisaProdutoContainer
                chamadoParaInserirProdutoNoOrcamento={true}
                pesquisandoApenasParaFiltroProdutosLupa={false}
                chamadoPeloTrocarProduto={false}
                foraOrcamento={false}
                regiaoRenderizada='conteudo-pagina'
                ocultarBarraPesquisa={false}
                passos={passosInterno.current}
                onVoltar={onVoltarGridItens}
                // adicionarProdutosCallBack={itemOrcamentoControllerRef.current.adicionarProdutos} 
                adicionarProdutosCallBack={() => { }}
                
            />,
            "conteudo-pagina",
            true
        )
    }

    const onRemoverServicoAgregado = async (identificadorItem: number) => {
        if (!isMounted.current) return
        try {

            globalMU.blockUI();
            var result = await RemoverServicosAgregados(
                orcamento.IdentificadorOrcamento,
                identificadorItem
            );

        } catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI()
        }
    }



    return <>
        <div id="ItensOrcamentoContainer_div-orcamento-react"
            style={{ marginRight: "5px" }}
        >

            <Breadcrumb2Container
                passos={["Itens"]}
                id="breadcrumb-itens-orcamento"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={false} />

            {dataInicialPrevisaoEntrega != null
                && exibirTextoTecnico != undefined
                && <BarraFerramentasContext.Provider value={{
                    orcamento,
                    limparCodigoOuReferenciaFlag,
                    dataMaximaParaPrevisaoEntrega,
                    onTipoEntregaPadrao: onTipoEntregaPadraoOrcamento, // 474918
                    //onBotaoIncluirClicado: renderizarTelaPesquisaProdutos,
                    onBotaoIncluirReactClicado: renderizarTelaPesquisaProdutosReact,

                    onRegistrarPerdaCotacaoReact: (perdaTotal: boolean) => {
                        /*
                        const itensSelecionados = (orcamento.ItensOrcamento ?? []).filter(i => i.selecionado == true)
                        */
                   
                        renderizarComponentReact(<RegistrarPerdaCotacaoContainer
                        identificadorItemSelecionado={!perdaTotal ? itensSelecionados[0].Identificador : undefined}
                        quantidadeProduto={!perdaTotal && itensSelecionados.length == 1 ? itensSelecionados[0].Quantidade : 0}
                        perdaTotal={perdaTotal} // 470698
                            onVoltar={() => {
                                $("#itens-orcamento-container").show()
                                removerComponenteReact("registrar-perda-cotacao-region");
                                renderizarComponentReact(<ItensOrcamentoContainer {...props} />, "conteudo-pagina", true)
                            }}
                        />, "conteudo-pagina", true)



                    },

                    onBotaoEditarReactClicado: (itens) => {

                        renderizarComponentReact(
                            <TelaEdicaoItensContainer
                                identificadoresItensSelecionados={itens.map(i => i.Identificador)}
                                itemOrcamentoController={itemOrcamentoControllerRef.current}
                            />,
                            "conteudo-pagina",
                            true
                        )

                    },

                    onBotaoExcluirClicado: async (itens) => {
                        await excluirItens(itens)



                    },
                    onCodigoOuReferenciaInformado: adicionarProdutoPorCodigoOuReferencia,
                    somarQuantidadeProdutoRepetidoPadrao: valorParametroPorFilial("VENDAS_INSERCAO_RAPIDA_SEMPRE_ADICIONAR_QUANTIDADE_AO_INFORMAR_O_MESMO_PRODUTO") == "S", // 491040
                    incluirProdutoPor: parametrosGridItens.find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor == "C" ? "CODIGO" : "REFERENCIA",
                    itensSelecionados, //(orcamento.ItensOrcamento ?? []).filter(i => i.selecionado == true)}
                    quantidadeItens: orcamento?.ItensOrcamento?.length ?? 0,
                    onSelecionarTodos: async (checked) => {

                        store.dispatch(checked ? selecionarTodosOsItensAction() : desselecionarTodosOsItensAction())

                        const itensLegado = window.orcamentoController?.model?.get('ItensOrcamento')?.models
                        if (Array.isArray(itensLegado)) {
                            for (let itemLegado of itensLegado) {
                                itemLegado.set('selecionado', checked, { silent: true })
                            }
                        }


                        // window.orcamentoController.model.get("ItensOrcamento").forEach(i => i.set("selecionado", checked))
                        // itemOrcamentoController.habilitarBotoes()
                    },
                    onSelecionarItemsPorTipoDeEntrega: async (codigoTipoEntrega, checked) => {
                        orcamento.ItensOrcamento
                            .filter(i => i.CodigoTipoEntrega == codigoTipoEntrega)
                            .forEach(i => store.dispatch(checked ? selecionarItemAction(i.Identificador) : desselecionarItemAction(i.Identificador)))


                    },

                    onAlterarEntregaPosterior: onAlterarEntregaPosteriorItens,
                    onAlterarTipoEntrega: alterarTipoEntrega,
                    onAlterarDataEntregaSelecionados: data => onAlterarDataEntregaSelecionados(globalMU.converterObjetoDateParaDataFormatoEN(data), itensSelecionados), // orcamento.ItensOrcamento?.filter(i => i.selecionado))}
                    onRemoverDataEntregaSelecionados: () => onAlterarDataEntregaSelecionados(null, itensSelecionados), // orcamento.ItensOrcamento?.filter(i => i.selecionado))}
                    onOrdenarItens: async () => {
                        if (ordenarItem && orcamento.ItensOrcamento) {
                            if (validarExisteOrdemItemRepetido())
                                return
                        }
                        setOrdenarItem(!ordenarItem)
                        if (ordenarItem) {
                            await reordenarItens(orcamento.ItensOrcamento)
                        }
                    },
                    onBotaoCompararClicado: () => {
                        //itemOrcamentoController.compararItens(itensSelecionados)
                    },
                    onAgruparPorAmbientes: () => setAgruparPorAmbientes(!agruparPorAmbientes),

                    exibirBotaoReservaLote,

                    onBotaoReservaLoteClicado: () => {

                        renderizarComponentReact(<ProdutosControleLoteContainer
                            onVoltar={onVoltarGridItens}
                            passos={passosInterno.current}
                        />, "conteudo-pagina", true)

                        // itemOrcamentoControllerRef.current.mostrarControleLote()
                    },

                    desativarBotaoReservaLote: (orcamento.ItensOrcamento ?? []).filter(i => i.ControleLote == true).length == 0,

                    desativarBotaoConsultarItens: (orcamento.ItensOrcamento ?? []).length == 0,

                    exibirBotaoOrdenarItens: true,

                    onRatearDespesas: definirDespesasInclusasItensSelecionados,

                    desativarMenuAcoes: itensSelecionados.length == 0, // (orcamento.ItensOrcamento ?? []).filter(i => i.selecionado == true).length == 0}

                    desativarBotaoComparar: itensSelecionados.length < 2, //((orcamento.ItensOrcamento ?? []).filter(i => i.selecionado).length < 2)}

                    desativarBotaoAmbientes: obterAmbientesPelosItens().length == 0,

                    dataInicialPrevisaoEntrega,
                    parametroUTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO: parametrosGridItensPorFilial.find(p => p.Nome == "UTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO")?.Valor === "S", //
                    permiteAcaoAlterarTipoEntregaNoAcoes: orcamento?.TipoEntregaPadrao == "" || orcamento?.TipoEntregaPadrao == "T", // 474918
                    onCompararItensClicado: async () => {
                        /*
                                            const itensSelecionados = orcamento?.ItensOrcamento?.filter(i => i.selecionado)
                        */
                        renderizarComponentReact(<CompararProdutosContainer
                            itens={itensSelecionados.map(i => i as IProduto)}
                            onVoltar={() => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)}
                            passos={new Dict<string, () => void>()
                                .set("Itens", () => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true))
                                .set("Comparar Produtos", () => { })}
                            regiaoRenderizada="conteudo-pagina" />,
                            "conteudo-pagina", true)


                        // const identificadoresItensSelecionados = orcamento.ItensOrcamento
                        //     .filter(i => i.selecionado == true)
                        //     .map(i => i.Identificador)

                        // const itens = window.orcamentoController.model.get('ItensOrcamento')
                        //     .toJSON()
                        //     .filter(i => R.includes(i.Identificador, identificadoresItensSelecionados))

                        // itemOrcamentoControllerRef.current.showView({
                        //     region: {
                        //         name: "compararProdutosControllerRegion",
                        //         selector: "#comparar-produtos-region"
                        //     },
                        //     controller: {
                        //         type: CompararProdutosController,
                        //         args: {
                        //             collection: itens,
                        //             readOnly: true
                        //         }
                        //     }
                        // })
                    },

                    exibirBotaoOfertaSeletiva: orcamento.TipoOrcamentoDescricao == "Venda" && parametrosGridItens.find(p => p.Nome == "OFERTA_SELETIVA")?.Valor == "S",

                    onOfertaSeletivaClicado: async () => {
                        await forEachSeries(
                            orcamento.ItensOrcamento.filter(i => i.selecionado == true && i.OidOferta > 0), async (item) => {
                                await definirOfertaSeletivaItem({
                                    identificadorItem: item.Identificador,
                                    ofertaSelecionada: item.OfertaSelecionada != 1
                                })
                            })
                    },

                    onBotaoConsultarItensClicado: async () => {
                        try {
                            globalMU.blockScreen()
                        const dadosOrcamentoParaConsultaItens_ = await microuniversoApi.Orcamento.listarItensOrcamento(orcamento.IdentificadorOrcamento)
                        if (!isMounted.current) return
                        setDadosOrcamentoParaConsultaItens(dadosOrcamentoParaConsultaItens_)

                        const colunaEhDeEstoqueDeFilial = (colunaNome) => /F[0-9]{2}/.test(colunaNome)
                        const a = (await microuniversoApi.Seguranca.obterDadosGridConsultaItensEstoque()) ?? []

                        const colunas = await R.pipe(
                            async () => (await microuniversoApi.Seguranca.obterDadosGridConsultaItens())?.Colunas ?? [],
                            R.andThen(colunas => colunas.filter(c => !colunaEhDeEstoqueDeFilial(c.Nome))),
                            R.andThen(colunas => [...colunas, ...a])
                        )()

                        const permissaoAcaoMostrarLocalRetirada = await permitidoAcaoFuncionalidade("ORCAMENTO_ITEM_VENDA", "MOSTRAR_LOCAL_RETIRADA")

                        if (!isMounted.current) return

                        setColunasConsultarItens(
                            obterColunasConsultaItens({
                                colunasDoCadastroDoUsuario: colunas,
                                parametros: parametrosGridItens,
                                parametrosPorFilial: parametrosGridItensPorFilial,
                                permissaoAcaoMostrarLocalRetirada,
                                tipoOrcamento: orcamento.TipoOrcamentoDescricao,
                                estoques: dadosOrcamentoParaConsultaItens_?.Itens?.[0]?.ListEstoqueProduto?.Estoques ?? [],
                                codigoFilialOrcamento: orcamento.CodigoFilialOrcamento
                            })
                        )

                        setExibirConsultaItens(true)
                        }
                        catch (e) {
                            tratamentoErroPadrao(e)
                        }finally {
                            globalMU.unblockScreen()
                        }
                    },

                    exibirAcaoRatearDespesasInclusas: orcamento.TipoOrcamentoDescricao != "Transferências" && valorParametro("EXIBIR_OUTRAS_DESPESAS_ITENS_ORCAMENTO") == "S",

                    onToggleExibirBarraFerramentas: (exibir) => {
                        if (orcamento.Vendedor?.Codigo != null) {
                            sessionStorage.setItem(`exibirBarraFerramentas-vendedor-${orcamento.Vendedor?.Codigo}`, exibir ? "true" : "false")
                        }
                    },

                    exibirBarraFerramentas: R.includes(sessionStorage.getItem(`exibirBarraFerramentas-vendedor-${orcamento.Vendedor?.Codigo}`), [null, undefined, "true"]),

                    onTrocarProduto: renderizarTelaPesquisaProdutosReact,
                    desativarBotaoTrocarProduto: itensSelecionados.length != 1,
                }}>
                    <BarraFerramentas />
                </BarraFerramentasContext.Provider>}
            {
                (orcamento.ItensOrcamento ?? []).length == 0 && <div className="_text-xl _mt-4">
                    Nenhum item no orçamento
                </div>
            }
            {

                !ordenarItem &&
                parametrosGridItens.length > 0 &&
                exibirTextoTecnico != null &&
                colunas.length > 0 &&
                (orcamento.ItensOrcamento ?? []).length > 0 &&
                <GridItensContext.Provider key={gridItensRedux.renderFlag} value={{
                    onMudarObs: (obs, item) => onAlterarObservacao(obs, item),
                    colunas,
                    orcamento,
                    parametrosGridItens,
                    parametrosGridItensPorFilial,
                    dataMaximaParaPrevisaoEntrega,
                    tiposEntrega,
                    onDataMarcadaAlterada: onDataMarcadaAlterado,
                    onDataPrevistaAlterada: onDataPrevistaAlterado,
                    onTipoEntregaAlterada,
                    onTurnoAlterada: onTurnoEntregaAlterado,
                    timezone: "America/Sao_Paulo",
                    numeroCasasDecimaisPreco: globalMU.isNotNullOrEmpty(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) ? Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) : 2,
                    numeroCasasDecimaisQuantidade: obterNumeroCasasDecimaisQuantidade(),
                    numeroCasasDecimaisPrecoTotal: 2,//{globalMU.isNotNullOrEmpty(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) ? Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) : 2}
                    onQuantidadeModificada: alterarQuantidadeItem,
                    onPrecoModificado: alterarPrecoItem,
                    onPorcentagemDescontoUnitarioModificado: alterarPorcentagemDescontoUnitario,
                    onModificadoPreservarDescontoUnitario: alterarPreservarDescontoUnitario,

                    onPercentualMarkupModificado: alterarPercentualMarkupItem,
                    onFilialRetiradaAlterada,
                    onFilialTransferenciaAlterada,
                    onAlterarMostruario, // PA 487087

                    onAlterarEntregaPosterior: onAlterarEntregaPosteriorItens,

                    onSimularPreco: onSimularPrecoItem, // 457575
                    permitirVisualizarSimulacaoDePreco, // 457575

                    onEditarItem: async (identificador) => {

                        renderizarComponentReact(
                            <TelaEdicaoItensContainer
                                identificadoresItensSelecionados={[identificador]}
                                itemOrcamentoController={itemOrcamentoControllerRef.current}
                            />,
                            "conteudo-pagina",
                            true
                        )
                    },
                    // Botao de excluir da propria linha (coluna Acoes): usa o mesmo caminho do
                    // botao Excluir da barra de ferramentas, so que com um item unico — assim
                    // ganha de graca o reposicionamento do scroll de excluirItens.
                    onExcluirItem: async (item) => {
                        await excluirItens([item])
                    },
                    onFocusFilialTransferencia: atualizarFiliaisTransferenciaItem,
                    onFocusFilialRetirada: atualizarFiliaisRetiradaItem,
                    filiaisRetiradaPorItem,
                    filiaisTransferenciaPorItem,
                    tiposFaturamento,
                    onFaturamentoAlterado: definirTipoFaturamento,
                    produtosFazemParteCampanhaCupomDesconto,

                    onEditarPedidoDeCompra: editarPedidoCompra,

                    onAlterarFonte: (fonte) => {
                        alterarFonte(fonte)
                        setTamanhoFonte(fonte)
                    },
                    tamanhoFontePadrao: tamanhoFonte,
                    permiteEngrenagemGrid, // 418506
                    exibirTextoTecnico,

                    onSelecionarItem: async item => {
                        //const itemAtualmenteEstaSelecionado = store?.getState?.()?.orcamento.ItensOrcamento.find(i => i.Identificador == item.Identificador)?.selecionado ?? false

                        store.dispatch(toggleSelecionarItemAction(item.Identificador))

                        //console.time('atualizarEstadoLegado ' + item.Identificador)

                        // await atualizarEstadoLegado({
                        //     atualizarTodosItensRedux: true,
                        //     removerPropriedadeSelecionado: false
                        // })

                        //const itemLegado = window.orcamentoController.model.get('ItensOrcamento').models.find(i => i.get('Identificador') == item.Identificador)

                        //itemLegado.set('selecionado', !itemLegado.get('selecionado'), { silent: true })

                        //itemOrcamentoControllerRef.current.habilitarBotoes()

                        // const itemLegado = window.orcamentoController.model.get("ItensOrcamento").find(i => i.get("Identificador") == item.Identificador)


                        // itemOrcamentoController.habilitarBotoes()
                    },

                    onExcluirAmbiente: excluirAmbiente,

                    onSalvarAmbiente: alterarAmbienteItem,

                    onAmbienteSelecionado: alterarAmbienteItem,

                    toggleLimparNovoAmbiente,

                    ambientes: obterAmbientesPelosItens(),
                    proximaCorAmbiente: obterProximaCorAmbiente(),

                    agruparPorAmbientes,

                    onToggleColunaSelecionada: toggleColunaSelecionada,

                    exibirIconeReservaLoteSePossivel: exibirBotaoReservaLote,

                    onAlterarCorTintometrico: async identificadorItem => {   // 455868
                        const item = orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem)
                        renderizarComponentReact(<EditarPrecoTintaContainer
                            item={item}
                            onRemover={() => onVoltarGridItens()}
                            onVoltar={onVoltarGridItens}
                            passos={passosInterno.current}
                            foraOrcamento={false}
                            somenteLeitura={orcamento.SomenteLeitura}
                        />, "conteudo-pagina",
                            true
                        )

                    },

                    onAlterarCorTintometricoSimplificado: async identificadorItem => {   // PA 402355 repasse 311033
                        const item = orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem)

                        renderizarComponentReact(<PesquisaCorTintaContainer
                            identificadorItem={item.Identificador}
                            codigoProduto={item.CodigoProduto}
                            codigoCorSelecionada={0}
                            onVoltar={onVoltarGridItens}
                            onRetornarCorSelecionada={onRetornoPesquisarCor}
                        />,
                            "conteudo-pagina",
                            true
                        )
                    },

                    onMostrarInformacoesProduto: async identificadorItem => {

                        const item = orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem)
                        renderizarComponentReact(<DetalheItemContainer item={item} onVoltar={onVoltarGridItens} />,
                            "conteudo-pagina",
                            true
                        )


                        // $("#itens-orcamento-container").hide()

                        // const itemLegado = window.orcamentoController.model.get('ItensOrcamento').find(i => i.get('Identificador') == identificadorItem)

                        // window.orcamentoController.showView({
                        //     region: {
                        //         name: "itemOrcamentoInfoViewRegion",
                        //         selector: "#detalhe-item-orcamento-region"
                        //     },
                        //     view: {
                        //         type: ItemOrcamentoInfoView,
                        //         args: {
                        //             controller: window.orcamentoController,
                        //             model: itemLegado
                        //         }
                        //     }
                        // })
                    },

                    onMostrarImagens: (identificadorItem, classeElementoAncora) => {
                        const item = (orcamento.ItensOrcamento ?? []).find(i => i.Identificador == identificadorItem)

                        $("." + classeElementoAncora).lightGallery({
                            dynamic: true,
                            dynamicEl: (item.Imagens ?? []).map(i => ({
                                subHtml: i.Nome,
                                src: i.Caminho,
                                thumb: i.Caminho
                            }))

                        });
                    },

                    onReservarLote: identificadorItem => {

                        renderizarComponentReact(<ProdutoLoteContainer
                            identificadorItem={identificadorItem}
                            onVoltar={onVoltarGridItens}
                            passos={passosInterno.current}
                        />, "conteudo-pagina", true)

                        // itemOrcamentoControllerRef.current.showView({
                        //     region: {
                        //         name: "lotesItemOrcamentoRegion",
                        //         selector: "#lotes-item-orcamento-region"
                        //     },
                        //     controller: {
                        //         type: LotesProdutoController,
                        //         args: {
                        //             orcamento: window.orcamentoController.model,
                        //             item: window.orcamentoController.model.get('ItensOrcamento').find(i => i.get('Identificador') == identificadorItem),
                        //             codigoObjetoItem: identificadorItem,
                        //             renderizarCallback: () => { }
                        //         }
                        //     }
                        // });
                    },

                    centrosCusto,

                    onBuscarOuInformarCentroCusto: atualizarEOuInformarCentroCusto,

                    onEditarLinhaOrdemPedidoCompraItem: editarLinhaOrdemPedidoCompraItem,

                    desativarEdicaoOrdemPedidoCompraItem: desativarEdicaoOrdemPedidoCompra,

                    onToggleSelecionarTodasColunas: toggleSelecionarTodasColunas,

                    onRemoverServicoAgregado: onRemoverServicoAgregado,

                    corItemSelecionado: globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo,

                    onAlterarVendaSobEncomenda: alterarVendaSobEncomenda,
                    onAlterarEncomendaExpressa: alterarEncomendaExpressa,
                    onAlterarPrioridadeMontagem: alterarPrioridadeMontagem, //456839
                    //tiposFreteDisponiveisPorItem: tiposFreteDisponiveisPorItemRef.current,
                    tiposFreteDisponiveisPorItem,
                    /* 444764
                    desativarCheckboxesVendaSobEncomendaItens: orcamento.SomenteLeitura || valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") == "1" || valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") == "2"
                    */
                    desativarCheckboxesVendaSobEncomendaItens: orcamento.SomenteLeitura || valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") == "1", // 444764
                    desativarCheckboxVendaEncomendaExpressaItens: orcamento.SomenteLeitura,
                }}>
                    <GridItens />
                </GridItensContext.Provider>
            }
            {
                ordenarItem &&
                exibirTextoTecnico != null &&
                <OrdenarItens
                    itens={orcamento.ItensOrcamento || []}
                    onChangeOrdem={(ordemItem, item) => {
                        const itemASerMudado = orcamento.ItensOrcamento.find((itemMudado) => itemMudado.OrdemItem == ordemItem)
                        store.dispatch(atualizarItemAction(
                            { identificador: itemASerMudado.Identificador, dados: { OrdemItem: item.OrdemItem } }
                        ))
                        store.dispatch(atualizarItemAction(
                            { identificador: item.Identificador, dados: { OrdemItem: ordemItem } }
                        ))
                    }}
                />
            }
            {exibirConsultaItens && <ConsultaItensDialog
                open={exibirConsultaItens}
                onClose={() => { setExibirConsultaItens(false) }}
                dadosOrcamento={dadosOrcamentoParaConsultaItens}
                rotuloColunaCodigoReferencia={R.includes(valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO"), ["C", null, undefined, ""]) ? "CODIGO" : "REFERENCIA"}
                numeroCasasDecimaisQuantidade={obterNumeroCasasDecimaisQuantidade()}
                numeroCasasDecimaisPreco={globalMU.isNotNullOrEmpty(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) ? Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) : 2}
                codigoFilialOrcamento={orcamento.CodigoFilialOrcamento}
                corPorAmbiente={corPorAmbiente}
                colunas={colunasConsultarItens}
                tamanhoFonte={tamanhoFonte}
                permiteEngrenagemGrid={permiteEngrenagemGrid} // 418506
                onToggleColunaSelecionada={toggleColunaSelecionadaConsultarItens}
                onToggleSelecionarTodasColunas={toggleSelecionarTodasColunasConsultarItens}
                parametro_CHAVE_MOVIMENTACAO_ORCAMENTO={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") as "C" | "R"}
            />
            }

            {dadosModalVendaSobEncomenda.mostrar && <ModalVendaSobEncomendaContainer
                onFecharCaixaDeDialogo={() => setDadosModalVendaSobEncomenda({
                    mostrar: false,
                    identificadorItem: null,
                    solicitacaoManual: false
                })}
                onCancelarCaixaDeDialogo={() => {

                    setDadosModalVendaSobEncomenda({
                        mostrar: false,
                        identificadorItem: null,
                        solicitacaoManual: false
                    })
                    alterarVendaSobEncomenda(false, dadosModalVendaSobEncomenda.identificadorItem)
                }}
                identificadorItem={dadosModalVendaSobEncomenda.identificadorItem}
                solicitacaoAberturaModalManual={dadosModalVendaSobEncomenda.solicitacaoManual} />}

        </div>
    </>
}